export default __webpack_public_path__ + "static/media/flag.80919dec.svg";